import { toSlug, toSlugInput } from '@repo/lib';

const endsWithDashOrSpace = ({ value }) => {
  const lastChar = value.slice(-1); // Get last character
  return lastChar === '-' || lastChar === ' ';
};

// allowDotsAndUnderscores is for manual slug-field input, where the dashboard
// charset permits them; title→slug generation stays strict to match the server.
const generateSlug = ({ value, allowTrailingDashOrSpace = true, allowDotsAndUnderscores = false }) => {
  const slug = allowDotsAndUnderscores ? toSlugInput(value) : toSlug(value);

  if (allowTrailingDashOrSpace === true && endsWithDashOrSpace({ value })) {
    return `${slug}-`;
  }

  return slug;
};

export default generateSlug;
